export type Record = { wins: number; losses: number; ties: number };

export const formatRecord = (record: Record): string => {
    return record.ties === 0 ? `${record.wins}-${record.losses}` : `${record.wins}-${record.losses}-${record.ties}`;
};

const parseRecordPart = (recordPart: string): number => {
    const parseResult = parseInt(recordPart);
    return Number.isNaN(parseResult) ? 0 : parseResult;
};

export const splitRecord = (record: string): Record => {
    const recordParts = record.split('-');

    return {
        wins: parseRecordPart(recordParts[0]),
        losses: parseRecordPart(recordParts[1]),
        ties: parseRecordPart(recordParts[2]),
    };
};
